import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SHORT_PLAIN_TEXT_200_LENGTH } from './common.constants';

export const AUDIO_BRIDGE_TEXT_ERROR = <FormattedMessage
    defaultMessage='This field is required'
    id='oe.error.required'
    description='Error message text'
/>;

export const AUDIO_BRIDGE_MAX_LENGTH_ERROR = <FormattedMessage
    id='oe.attendee.MaxLengthIs'
    description='Error label text'
    defaultMessage='Max length is {length} characters'
    values={{
        length: SHORT_PLAIN_TEXT_200_LENGTH
    }}
/>;

export const TIME_FIELD_ERROR_TEXT = <FormattedMessage
    id='oe.startEndTime.required'
    description='Error label text'
    defaultMessage='Start Time and End Time are required fields!'
/>;

export const START_TIME_ERROR_TEXT = <FormattedMessage
    id='oe.startEndTime.cannotBeEqualOrGreater'
    description='Error label text'
    defaultMessage='Start time cannot be equal or greater than End time'
/>;

export const START_TIME_PAST_TEXT = <FormattedMessage
    id='oe.startEndTime.cannotBeInPast'
    description='Error label text'
    defaultMessage='Start time cannot be in the past'
/>;

export const DURATION_ERROR_TEXT = <FormattedMessage
    id='oe.zoomWebinar.longerThenDay'
    description='Error label text'
    defaultMessage='Audio Bridge Connection cannot be longer than 24 hours'
/>;

export const AUDIO_BRIDGE_TOAST_MESSAGE = <FormattedMessage
    id='oe.createAudioBridge.audioBridgeIsBeingCreated'
    defaultMessage='Audio Bridge is being created'
    description='Notification text'
/>;

export const START_DATE = {
    id: 'oe.input.startDateTime',
    defaultMessage: 'Start Date and Time',
    description: 'Input label',
};

export const END_DATE = {
    id: 'oe.input.endDateTime',
    description: 'Input label',
    defaultMessage: 'End Date and Time'
};

export const TIME_ZONE = {
    id: 'oe.input.timeZone',
    description: 'Input label',
    defaultMessage: 'Time Zone'
};

export const PROVIDER = {
    id: 'oe.input.provider',
    description: 'Input label',
    defaultMessage: 'Provider'
};

export const AUDIO_BRIDGE_NAME = {
    id: 'oe.input.audioBridgeName',
    description: 'Input label',
    defaultMessage: 'Audio Bridge Name'
};

export const CONFERENCE_MODE = {
    id: 'oe.input.conferenceMode',
    description: 'Input label',
    defaultMessage: 'Conference Mode'
};

export const TELEPHONE_NUMBER_SET = {
    id: 'oe.input.telephoneNumberSet',
    description: 'Input label',
    defaultMessage: 'Telephone Number Set'
};

export const UNIQUE_DIALIN_CONNECTION_TOAST = <FormattedMessage
    id='oe.addAudioBridgeConnection.uniqueDialInConnectionCreation'
    defaultMessage='Unique Dial In connection created'
    description='Notification text'
/>;

export const AUDIO_BRIDGE_CONNECTION_LIST_TEXT = <FormattedMessage
    id='oe.common.selectAudioBridge'
    description='Text label'
    defaultMessage='Select Audio Bridge'
/>;

export const AUDIO_BRIDGE_ERROR_MESSAGE = <FormattedMessage
    id='oe.audioBridgeMeeting.audioBridgeNotFound'
    description='Info text'
    defaultMessage='Audio Bridge not found'
/>;

export const AUDIO_BRIDGE_SUCCESS_MESSAGE = <FormattedMessage
    id='oe.audioBridgeMeeting.audioBridgeFound'
    description='Info text'
    defaultMessage='Audio Bridge found'
/>;
